<template>
  <section id="workshops" class="layout-section -top-space">
    <div class="layout-section__hgroup">
      <h2 v-scroll:reveal class="layout-section__title">{{ $t('qigong.title') }}</h2>
      <p v-scroll:reveal="{ delay: 100 }">{{ $t('qigong.subtitle') }}</p>
    </div>

    <section class="layout-list">
      <a v-for="row in $t('qigong.workshops')" :key="row.date" v-scroll:reveal :href="row.link" target="_blank" rel="noopener noreferrer" class="layout-list__row">
        <h3 class="layout-list__heading">{{ row.title }}</h3>
        <p>{{ row.date }}</p>
        <p>{{ row.location }}</p>

        <div class="layout-list__link">
          <svg-icon id="arrow" />
        </div>
      </a>
    </section>
  </section>
</template>

<script>
export default {
  name: 'HomeGrid',
  /* props: {
    lang: { type: String, default: 'en' }
  } */
}
</script>
